// extracted by mini-css-extract-plugin
export default {"commonTemplatesFormItem":"styles_common-templates-form-item__-279c"};